<template>
  <div>
    <!-- Button Aviso de Privacidad -->
    <button
      type="button"
      id="btnAvisoPrivacidadModal"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#avisoPrivacidadModal"
      style="display: none;"
    >
      Modal Aviso de privacidad
    </button>

    <!-- Modal Aviso de Privacidad -->
    <div
      class="modal fade"
      id="avisoPrivacidadModal"
      tabindex="-1"
      aria-labelledby="avisoPrivacidadModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body text-center">
            <img
              src="./../assets/images/LogotipoLatinoSeguros.png"
              alt="Logo Latino Seguros"
              class="img-fluid w-75"
            />
            <p class="text-justify mb-4">
              Conozco y entiendo el Aviso de Privacidad Integral, el cual
              contiene y detalla las finalidades primarias y secundarias del
              tratamiento de mis datos personales y expresamente los sensibles,
              el cual se encuentra disponible en
              <a href="www.latinoseguros.com.mx" class="title" target="_blank"
                >www.latinoseguros.com.mx</a
              >
            </p>
            <button
              id="btnCerrarAvisoPrivacidad"
              type="button"
              class="btn btn-sm btn-primary btn-rounded" @click="enviarBitacoraAviso()"
              data-bs-dismiss="modal">
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    polizaMain: String,
    cerrarModal: Function
  },
  data: function() {
    return {};
  },
  methods: {
    onChange() {
      this.$emit("update:value", this.model);
    },
    enviarBitacoraAviso() {
      const payload = {
        metodo: "INSERTABITACORA",
        data: {
          MENSAJE: "acepta aviso de privacidad:" + this.polizaMain,
          PROCESO: "ProcesoCotizacionRenovacion",
          SISTEMA: "RenovacionValor"
        },
      };

      this.$store.dispatch("metodoPostWithoutLoading", payload);
      //$("#avisoPrivacidadModal").modal("hide");
    }
  },
};
</script>
